import {useQuery} from "~/apollo/patches";
import {
    GetCargoDetailDocument, GetCargoDetailQueryResult, GetCargoDetailQueryVars,
    GetCargoListDocument, getCargoListPathBuilder,
    GetCargoListQueryResult,
    GetCargoListQueryVars, ShortCargo
} from "~/apps/packages/cargos/queries";
import {useCallback, useEffect, useState} from "react";
import {useErrorHandler} from "~/components/ErrorHandling";
import {useApolloClient} from "@apollo/client";


export type useCargoListOptions = {
    status?: ShortCargo["status"][]
    query?: string
    dateFrom?: Date
    dateTo?: Date
}
export const useCargoList = (options: useCargoListOptions) => {
    const handleError = useErrorHandler();
    const {data, error, refetch, fetchMore: _fetchMore, loading} = useQuery<GetCargoListQueryResult, GetCargoListQueryVars>(GetCargoListDocument, {
        notifyOnNetworkStatusChange: true,
        variables: {
            status: options.status,
            query: options.query,
            dateFrom: options?.dateFrom?.getTime(),
            dateTo: options?.dateTo?.getTime(),
            pathBuilder: getCargoListPathBuilder
        }
    });
    const canFetchMore = Boolean(data?.cargoHistoryCargos?.pageInfo?.nextPage) && !loading;

    const fetchMore = useCallback(() => {
        if (!canFetchMore) {
            return;
        }
        _fetchMore({
            variables: {
                page: data.cargoHistoryCargos.pageInfo.nextPage
            },
        }).catch(handleError);
    }, [data, canFetchMore]);

    useEffect(() => {
        if (error) {
            handleError(error);
            const timeoutId = setTimeout(() => refetch(), 5000);
            return () => clearTimeout(timeoutId);
        }
    }, [error])

    return {
        data: data?.cargoHistoryCargos?.cargos,
        loading: loading || error != null,
        fetchMore,
        canFetchMore
    }
}


export const useCargoDetail = (id) => {
    const handleError = useErrorHandler();
    const {data, error, loading} = useQuery<GetCargoDetailQueryResult, GetCargoDetailQueryVars>(GetCargoDetailDocument, {
        variables: {
            id: id,
        },
        notifyOnNetworkStatusChange: true
    });

    useEffect(() => {
        if (error) {
            handleError(error);
        }
    }, [error])

    return {
        data: data?.cargo?.cargo,
        loading: loading || error != null
    };
}